import { defineCountry } from '../../../src/domain/country/factory';
import * as languages from '../../languages';

export default defineCountry({
  countryName: 'India',
  countryCode: 'IN',
  countryHeaderCode: 'in',
  mobileRegex: /^[6-9]\d{9}$/,
  mobileLength: 10,
  mobileCode: '+91',
  languages: {
    [languages.en.languageCode]: {
      bookingFlowConfig: {
        isDesktopBkfEnabled: true,
        isMobileBkfEnabled: true,
      },
      defaultAgreedDocs: {
        tncUrl: '/en-IN/terms-of-service',
        privacyPolicyUrl: '/en-IN/privacy-policy',
      },
      currencyConfig: {
        currencyLocale: 'en-IN',
        currencyCode: 'INR',
        maxMinorDigits: 2,
        currencySymbol: '₹',
      },
    },
  },
  defaultLanguage: languages.en,
  googleAutoCompletePlacesCode: 'in',
  trackOrderContactSupportNumber: '+912244104405',
});
